import gql from 'graphql-tag';

export const REGISTER_SMS_REJECTS = gql`
    mutation ($mobile_number: String!) {
        registSMSRejects(
            mobile_number: $mobile_number
        ){
            result
        }
    },
`;
